import React from 'react';
import { parse } from '@wordpress/block-serialization-default-parser';
import Fade from 'react-reveal/Fade';
import Image from '../Image';
import { StaticQuery, graphql } from 'gatsby';
import VideoPlayer from '../VideoPlayer';
import ReactHtmlParser from 'react-html-parser';
import {
	StFigure,
	StImage,
	CoreBlock,
	CoreParagraph,
	CoreVideoEmbed,
	CoreVideo,
	CoreMediaText,
	CoreVerse
} from './WordPressRawContent.css';
import GetVideo from './Getvideo';
import LottieObj from '../LottieObj';

const WordpressRawContent = ({ raw }) => {
	const parsedContent = parse(raw);

	return (
		<div className="wpcontent">
			{parsedContent.map((block, index) => {
				if (typeof block.blockName === 'object' && block.blockName === null) return null;

				if (block.blockName === 'advanced-gutenberg-blocks/code') {
					const { language, file } = block.attrs;
					if (language === 'js') {
						return <LottieObj key={index} jsonfile={file} />;
					}
				}

				if (block.blockName === 'core/image') {
					console.log('fabián véeme:', block.attrs.className);
					const parsedhtml = ReactHtmlParser(block.innerHTML);

					if (parsedhtml[0].type === 'figure') {
						const figure = parsedhtml[0];
						const figcaption = figure.props.children.filter((element) => element.type === 'figcaption');
						const validclasses = [ 'grayscale', 'duotone' ];
						const filteredarr = validclasses.filter(
							(value) => -1 !== figure.props.className.indexOf(value)
						);
						const typeclass = filteredarr && filteredarr.length > 0 ? filteredarr[0] : '';

						return (
							<StFigure key={index} className={block.attrs.className}>
								<WpImageToLocal wordpressid={block.attrs.id} type={typeclass} className={block.attrs.className} />
								{figcaption.length > 0 && <div className="figcap">{figcaption}</div>}
							</StFigure>
						);
					}

					return (
						<StImage key={index} className={block.attrs.className}>
							<WpImageToLocal wordpressid={block.attrs.id} />
						</StImage>
					)
				}
				if (block.blockName === 'core-embed/vimeo' || block.blockName === 'core-embed/youtube') {
					return (
						<Fade key={index}>
							<CoreVideoEmbed>
								<VideoPlayer url={block.attrs.url} key={index} />
							</CoreVideoEmbed>
						</Fade>
					);
				}

				if (block.blockName === 'core/quote') {
					return (
						<Fade key={index}>
							<CoreBlock dangerouslySetInnerHTML={{ __html: block.innerHTML }} />
						</Fade>
					);
				}

				if (block.blockName === 'core/list') {
					return (
						<Fade key={index}>
							<CoreBlock dangerouslySetInnerHTML={{ __html: block.innerHTML }} />
						</Fade>
					);
				}

				if (block.blockName === 'core/verse') {
					return (
						<Fade key={index}>
							<CoreVerse dangerouslySetInnerHTML={{ __html: block.innerHTML }} />
						</Fade>
					);
				}

				if (block.blockName === 'core/video') {
					const parsedhtml = ReactHtmlParser(block.innerHTML);
					if (parsedhtml[0].type === 'figure') {
						const figure = parsedhtml[0];
						if (figure.props.children) {
							if (figure.props.children[0]) {
								const srcurl = figure.props.children[0].props.src;
								const filename = srcurl.substring(srcurl.lastIndexOf('/') + 1);
								return (
									<Fade key={index}>
										<CoreVideo>
											<GetVideo filename={filename} noProportions controls={false} />
										</CoreVideo>
									</Fade>
								);
							}
						}
					}
				}

				if (block.blockName === 'core/media-text' && block.attrs.mediaType === 'image') {
					try {
						const parsedhtml = ReactHtmlParser(block.innerHTML);

						if (parsedhtml[0].props.children[0].props.children[0].props.src) {
							const srcurl = parsedhtml[0].props.children[0].props.children[0].props.src;
							const filename = srcurl.substring(srcurl.lastIndexOf('/') + 1);

							return (
								<CoreMediaText key={index}>
									<div className="col col1">
										<Image filename={filename} />
									</div>
									<div className="col col2">
										{block.innerBlocks.map((childblock, ind) => {
											const replacedhtml = childblock.innerHTML.replace(
												'data-tooltip',
												'data-tip'
											);
											return (
												<CoreParagraph
													key={ind}
													className="coreParagraph"
													dangerouslySetInnerHTML={{ __html: replacedhtml }}
												/>
											);
										})}
									</div>
								</CoreMediaText>
							);
						}
					} catch (err) {
						console.log(err);
					}
				}

				if (block.blockName === 'core/media-text' && block.attrs.mediaType === 'video') {
					const parsedhtml = ReactHtmlParser(block.innerHTML);

					if (parsedhtml[0].type === 'div') {
						const div = parsedhtml[0];
						if (div.props.children) {
							if (div.props.children[0]) {
								const srcurl = div.props.children[0].props.children[0].props.src;
								const filename = srcurl.substring(srcurl.lastIndexOf('/') + 1);

								return (
									<CoreMediaText key={index}>
										<div className="col col1">
											<GetVideo filename={filename} noProportions controls={false} />
										</div>
										<div className="col col2">
											{block.innerBlocks.map((childblock, ind) => {
												const replacedhtml = childblock.innerHTML.replace(
													'data-tooltip',
													'data-tip'
												);
												return (
													<CoreParagraph
														key={ind}
														className="coreParagraph"
														dangerouslySetInnerHTML={{ __html: replacedhtml }}
													/>
												);
											})}
										</div>
									</CoreMediaText>
								);
							}
						}
					}
				}

				if (block.blockName === 'core/paragraph') {
					const replacedhtml = block.innerHTML.replace('data-tooltip', 'data-tip');
					return (
						<Fade key={index}>
							<CoreParagraph
								className="coreParagraph"
								dangerouslySetInnerHTML={{ __html: replacedhtml }}
							/>
						</Fade>
					);
				} else {
					// console.log(block);
					return null;
				}
			})}
		</div>
	);
};

const WpImageToLocal = (props) => (
	<StaticQuery
		query={graphql`
			query {
				images: allWordpressWpMedia {
					edges {
						node {
							wordpress_id
							source_url
						}
					}
				}
			}
		`}
		render={(data) => {
			const imagepath = data.images.edges.find((n) => {
				return n.node.wordpress_id === props.wordpressid;
			});
			if (!imagepath) {
				return null;
			}
			const filename = imagepath.node.source_url.split('\\').pop().split('/').pop();
			return <Image filename={filename} type={props.type} />;
		}}
	/>
);

export default WordpressRawContent;
